import { useContext } from "react";
import AppInfoContext from "src/provider/state-manager/appInfoProvider";

function SvgComponent(props: any) {
  const {
    info: { theme },
  } = useContext(AppInfoContext);

  return (
    <svg
      width="21"
      height="22"
      viewBox="0 0 21 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_968_22805)">
        <path
          d="M10.4082 21.2807C16.014 21.2807 20.5585 16.7362 20.5585 11.1303C20.5585 5.52445 16.014 0.97998 10.4082 0.97998C4.80228 0.97998 0.257812 5.52445 0.257812 11.1303C0.257812 16.7362 4.80228 21.2807 10.4082 21.2807Z"
          fill="#F0F0F0"
        />
        <path
          d="M9.96875 11.1308H20.5604C20.5604 10.2147 20.4383 9.32717 20.2107 8.48291H9.96875V11.1308Z"
          fill="#D80027"
        />
        <path
          d="M9.96875 5.83446H19.0706C18.4492 4.82053 17.6548 3.92433 16.7285 3.18652H9.96875V5.83446Z"
          fill="#D80027"
        />
        <path
          d="M10.4083 21.2813C12.7971 21.2813 14.9928 20.4556 16.7267 19.0747H4.08984C5.82373 20.4556 8.01942 21.2813 10.4083 21.2813Z"
          fill="#D80027"
        />
        <path
          d="M1.74951 16.4258H19.0706C19.5694 15.6118 19.9563 14.7221 20.2107 13.7778H0.609375C0.863808 14.7221 1.25067 15.6118 1.74951 16.4258Z"
          fill="#D80027"
        />
        <path
          d="M4.95964 2.5651H5.88463L5.02423 3.19018L5.35289 4.20161L4.49253 3.57653L3.63217 4.20161L3.91606 3.32784C3.15851 3.95887 2.49454 4.69818 1.94737 5.52194H2.24375L1.69607 5.91983C1.61074 6.06217 1.52891 6.20678 1.45048 6.35352L1.71201 7.15845L1.22408 6.80394C1.10279 7.06091 0.991849 7.32367 0.89213 7.5919L1.18027 8.47879H2.24375L1.38335 9.10387L1.71201 10.1153L0.851648 9.49021L0.336279 9.86467C0.284695 10.2793 0.257812 10.7017 0.257812 11.1303H10.4082C10.4082 5.52448 10.4082 4.8636 10.4082 0.97998C8.40299 0.97998 6.53378 1.56164 4.95964 2.5651ZM5.35289 10.1153L4.49253 9.49021L3.63217 10.1153L3.96083 9.10387L3.10043 8.47879H4.16391L4.49253 7.46736L4.82115 8.47879H5.88463L5.02423 9.10387L5.35289 10.1153ZM5.02423 6.14702L5.35289 7.15845L4.49253 6.53337L3.63217 7.15845L3.96083 6.14702L3.10043 5.52194H4.16391L4.49253 4.51052L4.82115 5.52194H5.88463L5.02423 6.14702ZM8.99377 10.1153L8.13341 9.49021L7.27305 10.1153L7.60171 9.10387L6.74131 8.47879H7.8048L8.13341 7.46736L8.46203 8.47879H9.52552L8.66512 9.10387L8.99377 10.1153ZM8.66512 6.14702L8.99377 7.15845L8.13341 6.53337L7.27305 7.15845L7.60171 6.14702L6.74131 5.52194H7.8048L8.13341 4.51052L8.46203 5.52194H9.52552L8.66512 6.14702ZM8.66512 3.19018L8.99377 4.20161L8.13341 3.57653L7.27305 4.20161L7.60171 3.19018L6.74131 2.5651H7.8048L8.13341 1.55367L8.46203 2.5651H9.52552L8.66512 3.19018Z"
          fill="#0052B4"
        />
      </g>
      <defs>
        <clipPath id="clip0_968_22805">
          <rect
            width="20.3007"
            height="20.3007"
            fill="white"
            transform="translate(0.257812 0.97998)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
export default SvgComponent;
